// extracted by mini-css-extract-plugin
export default {"cashback":"style_cashback__NJ91z","content":"style_content__t7Lcn","bg_main":"style_bg_main__8518+","bg_top":"style_bg_top__loGrh"};